import {ActionContext, Module} from 'vuex';

// -------------------------------------------------------------------------
// Define Store State
// -------------------------------------------------------------------------

export interface ExampleStoreState {
    data: any;
}

type EmptyActionContext = ActionContext<ExampleStoreState, ExampleStoreState>;

// -------------------------------------------------------------------------
// Define Store Module
// -------------------------------------------------------------------------

export const EmptyStoreModule: Module<ExampleStoreState, any> = {
    // -------------------------------------------------------------------------
    // Define Initial state
    // -------------------------------------------------------------------------
    state: {
        data: undefined,
    },
    // -------------------------------------------------------------------------
    // Define getters
    // -------------------------------------------------------------------------
    getters: {},
    // -------------------------------------------------------------------------
    // Define actions
    // -------------------------------------------------------------------------
    actions: {},
    // -------------------------------------------------------------------------
    // Define mutations
    // -------------------------------------------------------------------------
    mutations: {},
};
